import React, { useContext, useEffect, useState } from "react";
import PageLayout from "../../layouts/PageLayout";
import { Row, Col } from "react-bootstrap";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import '../../components/cards/card.css';
import PeopleIcon from '@mui/icons-material/People';
import AddHomeWorkIcon from '@mui/icons-material/AddHomeWork';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import TodayIcon from '@mui/icons-material/Today';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';

export default function AnalyticsPage() {
    const { t } = useContext(TranslatorContext);

    const [Count, setCount] = useState({
        UserCount: 0,
        ClinicCount: 0,
        DoctorCount: 0,
        ClinicDoctorAppointmentCount: 0,
        ConsultationCount: 0,
        ServicesCount: 0,
        appointment_earning: 0,
        consultation_earning: 0

    });

    const id = localStorage.getItem('id');

    const getcount = () => {
        const user_type = localStorage.getItem('user_type');
        axios.post(API_URL + "/get_user_count", { user_type })
            .then((res) => {
                setCount(res.data);
                console.log(res.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        getcount();
    }, []);


    function formatCurrency(amount) {
        return new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    }


    return (
        <PageLayout>
            <Row>
                <Col xl={12} >
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('dashboard')}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item">
                                    <Link to='#' className="mc-breadcrumb-link">{t('home')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">
                                    <Link to='#' className="mc-breadcrumb-link">{t('dashboard')}</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Col>

                {/* Render analytics cards with dynamic data */}
                <Col xl={3} md={6} sm={12}>

                    <div className="card">
                        <Link to={APP_PREFIX_PATH + "/manage-users"} className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="card-heading">{t('users')}</h3>
                                <div ><PeopleIcon style={{ color: 'white', fontSize: "50px" }} /></div>
                            </div>

                            <p className="card-p mt-0" style={{ fontSize: '25px' }}>{Count.UserCount}</p>

                        </Link>

                    </div>

                </Col>

                <Col xl={3} md={6} sm={12}>
                    <div className="card2">
                        <Link to={APP_PREFIX_PATH + "/manage-clinics"} className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="card-heading">{t('clinics')}</h3>
                                <div><AddHomeWorkIcon style={{ color: 'white', fontSize: "50px" }} /></div>
                            </div>
                            <p className="card-p mt-0" style={{ fontSize: '25px' }}>{Count.ClinicCount}</p>
                        </Link>
                    </div>
                </Col>

                <Col xl={3} md={6} sm={12}>
                    <div className="card3">
                        <Link to={APP_PREFIX_PATH + "/manage-doctors"} className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="card-heading">{t('doctors')}</h3>
                                <div><GroupAddIcon style={{ color: 'white', fontSize: "50px" }} /></div>
                            </div>
                            <p className="card-p mt-0" style={{ fontSize: '25px' }}> {Count.DoctorCount}</p>
                        </Link>
                    </div>
                </Col>

                <Col xl={3} md={6} sm={12}>
                    <div className="card6">
                        <Link to={APP_PREFIX_PATH + "/manage-services"} className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="card-heading">{t('service')}</h3>
                                <div><FormatListBulletedIcon style={{ color: 'white', fontSize: "50px" }} /></div>
                            </div>

                            <p className="card-p mt-0" style={{ fontSize: '25px' }}>{Count.ServicesCount}</p>
                        </Link>
                    </div>
                </Col>

                <Col xl={3} md={6} sm={12}>
                    <div className="card4">
                        <Link to={APP_PREFIX_PATH + "/manage-appointment"} className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="card-heading">{t('appointment')}</h3>
                                <div><EditCalendarIcon style={{ color: 'white', fontSize: "47px" }} /></div>
                            </div>
                            <p className="card-p mt-0" style={{ fontSize: '25px' }}>{Count.ClinicDoctorAppointmentCount}</p>
                        </Link>
                    </div>
                </Col>

                <Col xl={3} md={6} sm={12}>
                    <div className="card5">
                        <Link to={APP_PREFIX_PATH + "/manage-consultation"} className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="card-heading">{t('consultation')}</h3>
                                <div ><TodayIcon style={{ color: 'white', fontSize: "48px" }} /></div>
                            </div>
                            <p className="card-p mt-0" style={{ fontSize: '25px' }}>{Count.ConsultationCount}</p>
                        </Link>
                    </div>
                </Col>

                <Col xl={3} md={6} sm={12}>
                    <div className="card7">
                        <Link to={APP_PREFIX_PATH + "/manage-appointment-payment"} className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="card-heading">{t('appointement_earning_report')}</h3>
                                <div ><AccountBalanceIcon style={{ color: 'white', fontSize: "48px" }} /></div>
                            </div>
                            <p className="card-p mt-0" style={{ fontSize: '25px' }}>{Count.appointment_earning ? formatCurrency(Count.appointment_earning) : 0}</p>
                        </Link>
                    </div>
                </Col>

                <Col xl={3} md={6} sm={12}>
                    <div className="card8">
                        <Link to={APP_PREFIX_PATH + "/manage-consultation-payment"} className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="card-heading">{t('consultaion_earning_report')}</h3>
                                <div ><AccountBalanceIcon style={{ color: 'white', fontSize: "48px" }} /></div>
                            </div>
                            <p className="card-p mt-0" style={{ fontSize: '25px' }}>{Count.consultation_earning ? formatCurrency(Count.consultation_earning) : 0}</p>
                        </Link>
                    </div>
                </Col>


                <Col xl={3} md={6} sm={12}>
                    <div className="card9">
                        <Link to={APP_PREFIX_PATH + "/manage-contactus"} className="w-100">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="card-heading">{t('contact_us')}</h3>
                                <div ><AddIcCallIcon style={{ color: 'white', fontSize: "48px" }} /></div>
                            </div>
                            <p className="card-p mt-0" style={{ fontSize: '25px' }}>{Count.ContactUsCount}</p>
                        </Link>
                    </div>
                </Col>



            </Row>
        </PageLayout>
    );
}
